import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import ProductCard from "../../components/cards/ProductCard";
import ErrorPage from "../../components/errorPage";
import AppFooter from "../../components/footer";
import NavBar from "../../components/NavBar";
import ProductCardSkeleton from "../../components/skeletons/ProductCardSkeleton";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { getAllSearchedProducts } from "../../services/productsFn";
import GlobalButton from "../../components/button";
import { t } from "i18next";

const SearchProductPage = () => {
  const params = useParams();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [productCount, setProductCount] = useState(0);
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("name") || "";
  const rating = queryParams.get("rating") || 0;

  useEffect(() => {
    fetchAllProducts(name, rating, page);
  }, [page]);

  const fetchAllProducts = async (name, rating, currentPage) => {
    try {
      const response = await getAllSearchedProducts(name, rating, currentPage);
      if (response.data.status === "success") {
        const data = response.data.data;
        setProductCount(data.products.length);
        setAllProducts((prev) => [...prev, ...data.products]);
      } else {
        setIsError(true);
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      setIsError(true);
      showSnackbar(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  if (isError) {
    return <ErrorPage onRetry={() => fetchAllProducts(name, rating, page)} />;
  }

  const handleShowMore = () => {
    setPage((prevPage) => prevPage + 1);
    setIsLoadingMore(true);
  };

  return (
    <>
      <NavBar />
      <Box component={"section"} py={6}>
        <Container maxWidth={"md"} sx={{ mt: 10, mb: 4 }}>
          <Typography
            variant="heading_services"
            component={"h1"}
            textAlign={"center"}
            lineHeight={"normal"}
          >
            {t("browseProducts")}{" "}
            <Typography variant="heading_services" textTransform={"capitalize"}>
              {name}
            </Typography>{" "}
            Collection!
          </Typography>
        </Container>
        <Container maxWidth={"lg"} sx={{ mt: 4 }}>
          <Grid container spacing={2} mt={5}>
            {isLoading ? (
              Array.from({ length: 8 }).map((_, index) => (
                <Grid key={index} item xs={6} sm={4} md={2.4}>
                  <ProductCardSkeleton />
                </Grid>
              ))
            ) : isLoading === false && allProducts?.length === 0 ? (
              <Box textAlign={"center"}>
                <Typography>{t("productNotFound")}</Typography>
              </Box>
            ) : (
              allProducts?.map((item, index) => (
                <Grid key={index} item xs={6} sm={4} md={2.4}>
                  <ProductCard cardData={item} colorName={"text.black"} />
                </Grid>
              ))
            )}
          </Grid>

          <Stack my={4} alignItems={"center"}>
            {productCount >= limit && (
              <GlobalButton
                btnText={"showMore"}
                handleClickBtn={handleShowMore}
                startIcon={isLoadingMore && <CircularProgress size={26} />}
                styleProps={{
                  height: 50,
                  width: 200,
                  backgroundColor: "text.white",
                  color: "text.black",
                  borderRadius: 1.5,
                  fontSize: "1rem",
                  fontWeight: 600,
                }}
              />
            )}
          </Stack>
        </Container>
      </Box>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default SearchProductPage;
